export const constants = {
    DATE_FORMAT: 'YYYY-MM-DD HH:mm:ss',
    DATE_DISPLAY: 'MM/DD/YYYY h:mm a'
}
